import React from 'react';
import { Link } from 'react-router-dom';
import Navbar from '@/components/site/Navbar';
import Contact from '@/components/site/Contact';
import Footer from '@/components/site/Footer';
import FloatingActions from '@/components/site/FloatingActions';
import useSEO from '@/hooks/useSEO';

export default function ContactPage() {
  useSEO({
    title: 'Contact Trendy Closet · Indian Clothing Boutique in Morrisville, NC',
    description: 'Visit Trendy Closet at 158 Liberty Rose Dr, Morrisville NC 27560. Open daily 4:30 PM – 8:30 PM. Call 984-377-9835 or text before your visit. Serving Cary, Raleigh, Durham.',
  });

  return (
    <main data-testid="contact-page" className="min-h-screen bg-ivory text-charcoal">
      <Navbar />
      <div className="pt-28">
        <div className="container-luxe">
          <nav className="flex items-center gap-2 text-xs uppercase tracking-[0.2em] text-charcoal/55 mb-6">
            <Link to="/" className="hover:text-maroon">Home</Link><span>/</span>
            <span className="text-charcoal">Contact</span>
          </nav>
        </div>
      </div>
      <Contact />
      <Footer />
      <FloatingActions />
    </main>
  );
}
